(function () {
  const CAR_FILTER_SELECTOR = '[data-car-filter]';
  const NON_CAR_SUBJECTS = ['animal', 'animals', 'natural', 'nature'];
  const CAR_COLLECTION_PATTERN = /(^|[-\s])(car|cars|automotive|italian-cars|british-cars|american-cars|french-cars|german-cars)([-\s]|$)/;

  const normalize = (value) => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();

  const isCarCollection = () => {
    const collectionContainer = document.querySelector('[data-collection-handle]');
    const handle = normalize(collectionContainer && collectionContainer.dataset.collectionHandle);
    return CAR_COLLECTION_PATTERN.test(handle);
  };

  const hasActiveCarFilter = () =>
    Array.from(document.querySelectorAll(CAR_FILTER_SELECTOR)).some((filter) =>
      filter.querySelector('input:checked')
    );

  const activeFacetTexts = () =>
    Array.from(document.querySelectorAll('.active-facets__button-inner'))
      .map((facet) => normalize(facet.textContent))
      .filter(Boolean);

  const hasCarRelatedSubject = () =>
    activeFacetTexts().some((text) => {
      if (!/(subject|theme|category)/.test(text)) return false;
      if (NON_CAR_SUBJECTS.some((subject) => text.includes(subject))) return false;
      return true;
    });

  const shouldShowCarFilters = () => isCarCollection() || hasActiveCarFilter() || hasCarRelatedSubject();

  const updateCarFilters = () => {
    const show = shouldShowCarFilters();

    document.querySelectorAll(CAR_FILTER_SELECTOR).forEach((filter) => {
      filter.hidden = !show;
      filter.classList.toggle('facets__car-filter--hidden', !show);
    });
  };

  document.addEventListener('DOMContentLoaded', updateCarFilters);
  document.addEventListener('collection:grid-updated', updateCarFilters);
  window.addEventListener('popstate', updateCarFilters);
})();
